/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import isEqual from 'lodash.isequal';

// Hook
export default function useKeypressTools(toolsKeyMap, handlerSelectTool) {
  useEffect(() => {
    const downHandler = ({ repeat, ctrlKey, altKey, metaKey, shiftKey, key }) => {
      if (repeat) return;

      const keyLowerCase = key.toLowerCase();
      const keysPressed = {
        ...(altKey) ? { altKey } : {},
        ...(ctrlKey) ? { ctrlKey } : {},
        ...(shiftKey) ? { ctrlKey } : {},
        ...(metaKey) ? { ctrlKey } : {},
        ...(key !== 'Control' && key !== 'Shift' && key !== 'Alt' && key !== 'Meta')
          ? { key: keyLowerCase } : {},
      };

      for (let i = 0; i < toolsKeyMap.length; i++) {
        const tool = toolsKeyMap[i];
        if (isEqual(tool.keysPressed, keysPressed)) {
          handlerSelectTool(tool);
          break;
        }
      }
    };

    window.addEventListener('keydown', downHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
    };
  }, [toolsKeyMap]);
}
